export default (that) => [
  {
    text: that.$l('INDEX.btn_tips_view') || '查看',
    icon: 'el-icon-view',
    menuType: 'detail',
    showMenu: () => true,
  },
  {
    text: that.$l('INDEX.btn_tips_edit') || '编辑',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: false,
    allow: 'M',
    data: {},
    showMenu: ({ platformStatus }) => platformStatus === 'Y',
  },
  {
    text: that.$l('INDEX.btn_tips_del') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    showMenu: ({ platformStatus }) => platformStatus === 'Y',
  },
]
